import { localizeConfig, type TranslateFn } from './localize'

export type ConfigItem = Record<string, any>

const paytableConfig: ConfigItem[] = [
	{
		type: "subtitle",
		subTitleCss: "subTitle",
		align: "left",
		additionalCss: "cssclass",
		text: "Paytable",
	},
	{
		type: "title",
		titleCss: "title",
		align: "center",
		additionalCss: "cssclass",
		text: "GAME FEATURES",
	},
	{
		type: "title",
		titleCss: "title",
		align: "center",
		additionalCss: "cssclass",
		text: "AVALANCHE FEATURE",
	},
	{
		type: "list",
		align: "left",
		listCss: "listStyle",
		additionalCss: "cssclass",
		text: [
			"To win, player must match 8 or more symbols anywhere on the screen.",
			"Winning symbols will then disappear, and new symbols will cascade in their place, creating a new winning combination in a single spin.",
		],
	},
	{
		type: "title",
		titleCss: "title",
		align: "center",
		additionalCss: "cssclass",
		text: "FREE SPINS FEATURE",
	},
	{
		type: "list",
		align: "left",
		listCss: "listStyle",
		additionalCss: "cssclass",
		text: [
			"4 or more Bonus symbols appearing on the base game awards 10 free spins.",
			"Free spins can be retriggered. If 3 or more Bonus symbols are triggered, 5 more free spins are awarded additionally.",
			"Up to 40 additional free spins can be awarded.",
			"During the free game, there is a Multiplier symbol (Candy Jar) which may appear on the reels and stays until free spin micro round is completed. Multiplier on Candy Jar symbol is multiplied with the total win of each spin.  If there are more than one Candy Jar symbol then all Multipliers on them are added together and is multiplied with the total win of each spin.",
			"When Candy Jar symbol lands on the screen, it awards a random multiplier with possible values of 2x, 3x, 4x, 5x, 6x,8x, 10x, 15x, 20x,25x, 50x, 100x.",
		],
	},
	{
		type: "title",
		titleCss: "title",
		align: "center",
		additionalCss: "cssclass",
		text: "BUY BONUS",
	},
	{
		type: "list",
		align: "left",
		listCss: "listStyle",
		additionalCss: "cssclass",
		text: [
			"During the main game, player will have an option to BUY BONUS.",
			"Buy Bonus Price is 80 x Total Bets.",
		],
	},
	{
		type: "title",
		titleCss: "title",
		align: "center",
		additionalCss: "cssclass",
		text: "BUY BONUS",
	},
	// {
	// 	type: "image",
	// 	imgCSS: "image",
	// 	align: "center",
	// 	additionalCss: "splSymbol1",
	// 	imgPath: "/assets/infopages/symbols/buyfeature.png",
	// 	imgName: "buyfeature.png",
	// },
	{
		type: "list",
		align: "left",
		listCss: "listStyle",
		additionalCss: "cssclass",
		text: [
			"During the main game, player will have an option to BUY BONUS.",
			"Buy Bonus Price is 80 x Total Bets.",
		],
	},
	{ type: "payouts", text1: ["x5", "x4", "x3"], text2: ["- 90", "- 50", "- 5"], imgPath: "/assets/infopages/symbols/a.png", imgName: "a.png", align: "left" },
	{ type: "payouts", text1: ["x5", "x4", "x3"], text2: ["- 80", "- 30", "- 4"], imgPath: "/assets/infopages/symbols/b.png", imgName: "b.png", align: "left" },
	{ type: "payouts", text1: ["x5", "x4", "x3"], text2: ["- 60", "- 20", "- 3"], imgPath: "/assets/infopages/symbols/c.png", imgName: "c.png", align: "left" },
	{ type: "payouts", text1: ["x5", "x4", "x3"], text2: ["- 40", "- 9", "- 2"], imgPath: "/assets/infopages/symbols/d.png", imgName: "d.png", align: "left" },
	{ type: "payouts", text1: ["x5", "x4", "x3"], text2: ["- 25", "- 8", "- 2"], imgPath: "/assets/infopages/symbols/e.png", imgName: "e.png", align: "left" },
	{ type: "payouts", text1: ["x5", "x4", "x3"], text2: ["- 25", "- 8", "- 2"], imgPath: "/assets/infopages/symbols/f.png", imgName: "f.png", align: "left" },
	{ type: "payouts", text1: ["x5", "x4", "x3"], text2: ["- 9", "- 4", "- 1"], imgPath: "/assets/infopages/symbols/g.png", imgName: "g.png", align: "left" },
	{ type: "payouts", text1: ["x5", "x4", "x3"], text2: ["- 9", "- 4", "- 1"], imgPath: "/assets/infopages/symbols/h.png", imgName: "h.png", align: "left" },
	{
		type: "title",
		titleCss: "title",
		align: "center",
		additionalCss: "nextLine",
		text: "Win Lines",
	},
	{
		type: "image",
		imgCSS: "image",
		align: "center",
		additionalCss: "splSymbol2",
		imgPath: "/assets/infopages/symbols/ptWinLines.png",
		imgName: "ptWinLines.png",
	},
	{
		type: "title",
		titleCss: "title",
		align: "center",
		additionalCss: "nextLine",
		text: "GAME RULES",
	},
	{
		type: "list",
		align: "left",
		listCss: "listStyle",
		additionalCss: "cssclass",
		text: [
			"The game is 5 reels and 7 rows slot game.",
			"Any horizontal or vertical line of 3 or more adjacent symbols of the same symbols is a win match.",
			"Only the longest matching combination for a given symbol in a matching line is paid.",
			"Winning combinations and payouts are made according to the paytable.",
			"Malfunction voids all pays and plays.",
			"For this game, the long-term expected payback is 94.68%.",
		],
	},
]

export const getPaytableConfig = (translate: TranslateFn): ConfigItem[] => localizeConfig(paytableConfig, translate)
